import React, { Component } from 'react'
import { ScrollView } from 'react-native'

// import styles from './styles'
import { HGView, HGHeading } from '../../components/HGUI'

class StartOverviewAdultsScreen extends Component {
  render() {
    return (
      <ScrollView>
        <HGView>
          <HGHeading>StartOverviewAdults</HGHeading>
        </HGView>
      </ScrollView>
    )
  }
}

export default StartOverviewAdultsScreen
